import styled from "@emotion/styled";

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FormRow = styled.div`
    display: flex;
    column-gap: 10px;
    justify-content: center;
    margin: 20px 0 30px;
`;

export const ActionRow = styled.div`
    display: flex;
    justify-content: space-evenly;
`;

export const InputWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

const styledComponents = {
    FormContainer,
    FormRow,
    ActionRow,
    InputWrapper,
};

export default styledComponents;
